import React from 'react';
import { Section, SectionHead, Card, CardText } from './primitives';

// Unnumbered on purpose — these are alternatives, not a sequence.
const SEGMENTS = [
  {
    title: 'Prop desks & trading firms',
    body: 'Give every trader an always-on research analyst, with position sizing and approval gates set by your risk team.',
  },
  {
    title: 'Exchanges, brokers & wallets',
    body: 'Add an AI trading intelligence product to an existing user base without building a new engineering org around it.',
  },
  {
    title: 'Trading communities & educators',
    body: 'Turn a Discord or a subscriber list into a product: your agents, your personas, your recommendations, your subscription tiers.',
  },
  {
    title: 'DAOs & treasury managers',
    body: 'Documented reasoning and a full audit trail behind every position — useful when the mandate requires you to show your work.',
  },
  {
    title: 'Fintech & quant startups',
    body: 'Use the platform as your foundation and put your engineering effort into the strategies that differentiate you.',
  },
  {
    title: 'Regulated or restricted regions',
    body: 'Deploy in a specific jurisdiction, on a specific cloud, under your own compliance and data-residency requirements.',
  },
];

export const Segments = () => (
  <Section id="who">
    <SectionHead
      eyebrow="Who it's for"
      title="Built for teams that already have traders."
      lede="If you have an audience, a desk, or a treasury, Katbot gives you the intelligence layer to serve them."
    />
    <div className="grid gap-[18px] sm:grid-cols-2 lg:grid-cols-3">
      {SEGMENTS.map((s) => (
        <Card key={s.title} title={s.title}>
          <CardText>{s.body}</CardText>
        </Card>
      ))}
    </div>
  </Section>
);

export default Segments;
